import React, { Component } from 'react';

import './CancelButton.css'

import cancel from './.image/cancel.png'
export class CancelButton extends Component {
    render() {
        return (
            <div className='cancelButton' 
            style={{ 
                width: this.props.width ? this.props.width : '35px', 
                height: this.props.height ? this.props.height : '35px',
                lineHeight: `${this.props.height ? this.props.height-8 : 35}px`
            }}
            onClick={this.props.onClick}>
                <img src={cancel} width={this.props.width} height={this.props.height} alt="取消"/>
            </div>
        );
    }
}